import initNitro from "./lib/nitro";
import initMove, { submitMove, submitMoveWithAction } from "./lib/move";
import { init as initHashTracking } from "./lib/hash-tracking";
import { init as initEchTracking } from "./lib/external-call-tracking";
import { init as initLinkData, trackOnNextPageImpression } from "./lib/link-data";
import {
  closeContext,
  createContext,
  createEventMergeContext,
  init as initBct,
  replaceContext,
} from "./lib/bct";
import {
  createPage,
  sendEventToGate,
  sendMergeToGate,
  sendMiniActionsToGate,
  submitEvent,
  submitEventMerge,
  submitMerge,
  trackBlockedFeatures,
} from "./lib/request";
import { getMergeParameters, getPageId } from "./lib/url-helper";
import initAsync from "./lib/async";
import { init as initViewtimeTracking } from "./lib/viewtime";
import { onLoad, onReady } from "@otto-ec/global-resources/dom";
import { captureError } from "@otto-ec/global-resources/apm";

onLoad.subscribe(initNitro);
onReady.subscribe(initMove);
onReady.subscribe(initLinkData);
onReady.subscribe(initBct);
onReady.subscribe(initAsync);
onReady.subscribe(initEchTracking);
onReady.subscribe(initHashTracking);
onReady.subscribe(initViewtimeTracking);

window.o_tracking = window.o_tracking || {};

function captureDeprecatedApiCall<T, A extends unknown[], R>(fn: (this: T, ...args: A) => R) {
  return function (this: T, ...args: A): R {
    captureError(
      new Error("Deprecated bct tracking API used"),
      { team: "tracking", service: "bct" },
      { custom: { additionalInfo: "Deprecated bct tracking API used" } },
    );

    return fn.apply(this, args);
  }
}

window.o_tracking.bct = {
  closeContext: captureDeprecatedApiCall(closeContext),
  createContext: captureDeprecatedApiCall(createContext),
  replaceContext: captureDeprecatedApiCall(replaceContext),
  getMergeParameters: captureDeprecatedApiCall(getMergeParameters),
  sendEventToTrackingServer: captureDeprecatedApiCall(sendEventToGate),
  sendMergeToTrackingServer: captureDeprecatedApiCall(sendMergeToGate),
  createEventMergeContext: captureDeprecatedApiCall(createEventMergeContext),
  sendEventMergeToTrackingServer: captureDeprecatedApiCall(sendEventToGate),
  trackOnNextPageImpression: captureDeprecatedApiCall(trackOnNextPageImpression),
  submitMove: captureDeprecatedApiCall(submitMove),
};

/*                   */
otto.tracking.assignNamespace({
  createPage,
  submitEvent,
  submitEventMerge,
  submitMerge,
  submitMove: (datacontainer, action) => {
    submitMoveWithAction(datacontainer, action);
  },
  submitMiniAction: async (updates) => {
    await sendMiniActionsToGate(updates);
  },
  createEventMergeContext,
  trackOnNextPageImpression: (datacontainer) => {
    trackOnNextPageImpression(datacontainer);
  },
  createContext: (id, url, datacontainer) => {
    createContext(id, url, datacontainer);
  },
  replaceContext: (id, url, datacontainer) => {
    replaceContext(id, url, datacontainer);
  },
  closeContext,
  getPageMergeId: getPageId,
  trackBlockedFeatures
});

window.o_global.eventQBus.emitModuleLoaded("tracking.bct.bct");
